var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.208 5.35425C23.1103 4.7009 22.7817 4.10419 22.2818 3.67229C21.7819 3.24038 21.1439 3.00188 20.4833 3H3.51675C2.85614 3.00188 2.21806 3.24038 1.71819 3.67229C1.21831 4.10419 0.889731 4.7009 0.792004 5.35425L12 12.6068L23.208 5.35425Z",
    fill: "#40189D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4072 14.13C12.2859 14.2084 12.1445 14.2502 12 14.2502C11.8555 14.2502 11.7141 14.2084 11.5927 14.13L0.75 7.11449V18.2332C0.750794 18.9668 1.04255 19.6701 1.56124 20.1888C2.07993 20.7074 2.78321 20.9992 3.51675 21H20.4832C21.2168 20.9992 21.9201 20.7074 22.4388 20.1888C22.9575 19.6701 23.2492 18.9668 23.25 18.2332V7.11374L12.4072 14.13Z",
    fill: "#40189D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.757321951ff5728562322906f200f24e.svg";
export { ForwardRef as ReactComponent };